module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "plm_hd"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/DIS_contents"
    }
  }, [_vm._v("A note to the reader")])]), _vm._v(" "), _c('p', {
    staticClass: "fo"
  }, [_vm._v("The original book entitled "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Contemporary Christian")]), _vm._v(", on which this volume and series are based, may not seem ‘contemporary’ to readers more than a quarter of a century later. But both the publisher and John Stott’s Literary Executors are convinced that the issues which John Stott addresses in this book are every bit as relevant today as when they were first written.")]), _vm._v(" "), _c('p', {
    staticClass: "pi"
  }, [_vm._v("The question was how to make this seminal work accessible for new generations of readers. We have sought to do this in the following ways:")]), _vm._v(" "), _c('ul', {
    staticClass: "lst_blt1"
  }, [_c('li', [_vm._v("The original work has been divided into a series of several smaller volumes based on the five major sections of the original.")]), _vm._v(" "), _c('li', [_vm._v("Words that may not resonate with the twenty-first-century reader have been updated, while great care has been taken to maintain the thought process and style of the author in the original.")]), _vm._v(" "), _c('li', [_vm._v("Each chapter is now followed by questions from a current bestselling Christian author to aid reflection and response. ")])]), _vm._v(" "), _c('p', {
    staticClass: "fo_space"
  }, [_vm._v("Lovers of the original work have expressed delight that this book is being made available in a way that extends its reach and influence well into a new century. We pray that your life will be enriched as you read, as the lives of many have already been greatly enriched by the original edition.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5710d2be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/DIS_notetoreader.vue
// module id = 78
// module chunks = 0